module.exports = __webpack_public_path__ + "img/yishi29.bbf717f4.jpg";